import { Grid2 as Grid, Typography } from "@mui/material";
import TeacherDataTable from "../../_components/TeacherDataTable";

const PendingLessons = () => {
  return (
    <>
      <Grid container spacing={2} justifyContent="space-between" alignItems="center">
        <Typography variant="title">Pending Lessons</Typography>

        <TeacherDataTable
          title="pending-lessons"
          header={false}
          rows={[]}
          column={["Title", "Type", "Assigned On", "Due Date", "Due Days"]}
        />
      </Grid>
    </>
  );
};

export default PendingLessons;
